import { gql, TypedDocumentNode } from '@apollo/client'
import { QueryPageableRequest, QueryPageableResponse } from '../../../core/type'
import { ServiceType } from '../type/serviceType'

export const GetServiceTypesQuery: TypedDocumentNode<
  QueryPageableResponse<ServiceType, 'appointmentServiceTypesFind'>,
  QueryPageableRequest<{ includeDeleted?: boolean }>
> = gql`
    query GetAppointmentServiceTypes($request: AppointmentServiceTypeFindRequestInput!) {
        appointmentServiceTypesFind(request: $request) {
            data {
                id
                label
                sortOrder
                isActive
                deletedAt
            }
            count
        }
    }
`

export const GetActiveServiceTypesQuery: TypedDocumentNode<{
  appointmentServiceTypesActive: Pick<ServiceType, 'id' | 'label'>[]
}> = gql`
    query GetActiveAppointmentServiceTypes {
        appointmentServiceTypesActive {
            id
            label
        }
    }
`

export const CreateServiceTypeMutation: TypedDocumentNode<void, { dto: { label: string } }> = gql`
    mutation CreateAppointmentServiceType($dto: AppointmentServiceTypeInput!) {
        appointmentServiceTypeCreate(dto: $dto)
    }
`

export const UpdateServiceTypeMutation: TypedDocumentNode<void, { id: number; dto: { label: string } }> = gql`
    mutation UpdateAppointmentServiceType($id: Int!, $dto: AppointmentServiceTypeInput!) {
        appointmentServiceTypeUpdate(id: $id, dto: $dto)
    }
`

export const ToggleActiveServiceTypeMutation: TypedDocumentNode<void, { id: number }> = gql`
    mutation ToggleActiveAppointmentServiceType($id: Int!) {
        appointmentServiceTypeToggleActive(id: $id)
    }
`

export const ReorderServiceTypesMutation: TypedDocumentNode<void, { dto: { ids: number[] } }> = gql`
    mutation ReorderAppointmentServiceTypes($dto: AppointmentServiceTypeReorderInput!) {
        appointmentServiceTypeReorder(dto: $dto)
    }
`

export const DeleteServiceTypeMutation: TypedDocumentNode<void, { id: number }> = gql`
    mutation DeleteAppointmentServiceType($id: Int!) {
        appointmentServiceTypeDelete(id: $id)
    }
`

export const RestoreServiceTypeMutation: TypedDocumentNode<void, { id: number }> = gql`
    mutation RestoreAppointmentServiceType($id: Int!) {
        appointmentServiceTypeRestore(id: $id)
    }
`
